/* global $ */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import axiosInstance from '../axiosInstance';
import html2pdf from 'html2pdf.js';

function Buyer() {
    const [registrationno, setRegistrationno] = useState('');
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [company, setCompanyData] = useState({});

    const handleClear = () => {
        setRegistrationno('');
        setData([]);
    };

    // useEffect(() => {
    //     console.log('Updated companyData:', company);
    // }, [company]);

    useEffect(() => {
        const storedData = {
            company_name: localStorage.getItem('companyname') || '',
            company_address1: localStorage.getItem('address1') || '',
            company_address2: localStorage.getItem('address2') || '',
            company_city: localStorage.getItem('city') || '',
            company_phone1: localStorage.getItem('Phone1') || '',
            company_phone2: localStorage.getItem('phone2') || '',
        };
        setCompanyData(storedData);
    }, []);

    // Fetch all buyers once
    useEffect(() => {
        const fetchAllBuyers = async () => {
            try {
                const res = await axiosInstance.get(`/buyer`);
                setData(res.data);
            } catch (error) {
                Swal.fire('Error', 'Failed to fetch buyers', 'error');
                setData([]);
            }
        };

        fetchAllBuyers();
    }, []);

    const handleSearch = async (e) => {
        e.preventDefault();

        if (!registrationno) {
            Swal.fire('Error!', 'Please Give the Vehicle Registration Number to search bills', 'error');
            return;
        }

        try {
            const response = await axiosInstance.get(`/buyer/${registrationno}`);
            console.log(response.data)

            setData(response.data);
        } catch (error) {
            console.error('Error fetching vehicle registraion number data', error);
            const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
            Swal.fire('Error!', `There was an issue in searching the registration records: ${errorMessage}`, 'error');
            setData([]);
        }
    };

    const printBill = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });

        if (!result.isConfirmed) return;

        // ✅ Set selectedRow and wait for React to re-render before printing
        setSelectedRow(row);

        // ✅ Wait for state update + DOM render
        setTimeout(() => {
            const printContents = document.getElementById("download_section").innerHTML;
            document.body.innerHTML = printContents;

            const images = document.body.getElementsByTagName("img");
            let loadedCount = 0;
            const totalImages = images.length;

            if (totalImages === 0) {
                window.print();
                window.location.reload();
                return;
            }

            for (let img of images) {
                img.onload = img.onerror = () => {
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        window.print();
                        window.location.reload();
                    }
                };

                // ✅ If image already loaded (cached), trigger manually
                if (img.complete) {
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        window.print();
                        window.location.reload();
                    }
                }
            }
        }, 300); // ✅ 300ms gives React time to re-render with new selectedRow
    };

    const downloadPDF = (row) => {
        setSelectedRow(row);

        setTimeout(() => {
            const element = document.getElementById("download_section");
            element.style.display = "block";

            const elementWidth = element.scrollWidth;
            const elementHeight = element.scrollHeight;

            const options = {
                margin: 0,
                filename: `Bill_${row?.bill_no || 'invoice'}.pdf`,
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: {
                    scale: 1,
                    useCORS: true,
                    allowTaint: false,
                    logging: false,
                    width: elementWidth,
                    height: elementHeight,
                    windowWidth: elementWidth,   // ✅ renders at exact element width
                    windowHeight: elementHeight,
                },
                jsPDF: {
                    unit: 'px',
                    format: [elementWidth, elementHeight], // ✅ single page, exact size
                    orientation: 'portrait',
                    hotfixes: ['px_scaling'],
                }
            };

            html2pdf()
                .set(options)
                .from(element)
                .save()
                .then(() => {
                    element.style.display = "none";
                });
        }, 300);
    };

    const printBillWithFiles = async (row) => {
        setSelectedRow(row);

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });

        if (result.isConfirmed) {
            // Store original content
            const originalContents = document.body.innerHTML;

            // Create a temporary container div
            const tempContainer = document.createElement('div');

            // Copy the download_section as is
            tempContainer.innerHTML = document.getElementById("download_section").innerHTML;

            // Create a div to hold the images
            const imagesDiv = document.createElement('div');
            imagesDiv.style.marginTop = "20px";

            // Function to convert an image URL to a base64 string
            const loadImageAsBase64 = (url) => {
                return new Promise((resolve, reject) => {
                    // Create a new image element
                    const img = new Image();
                    img.crossOrigin = "Anonymous"; // Try to handle CORS

                    img.onload = () => {
                        // Create a canvas to draw the image
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;

                        // Draw the image on the canvas
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);

                        // Get the base64 data
                        try {
                            const dataURL = canvas.toDataURL('image/png');
                            resolve(dataURL);
                        } catch (e) {
                            // If we can't get dataURL (e.g., CORS issues), just use the original URL
                            resolve(url);
                        }
                    };

                    img.onerror = () => {
                        console.error(`Failed to load image: ${url}`);
                        resolve(null); // Resolve with null to allow other images to continue
                    };

                    img.src = url;
                });
            };

            // Load all images, convert to base64 if possible
            const fileUrls = [
                row.files?.aadhar_file?.url,
                row.files?.rc_file?.url,
                row.files?.photowithbike_file?.url
            ].filter(url => url);

            try {
                // Show loading indicator
                Swal.fire({
                    title: 'Preparing print...',
                    text: 'Loading images, please wait...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                // Wait for all images to load
                for (let i = 0; i < fileUrls.length; i++) {
                    const fileUrl = fileUrls[i];
                    try {
                        // Try to get base64 version (helps with cross-origin issues)
                        const imgData = await loadImageAsBase64(fileUrl);

                        if (imgData) {
                            const imgElement = document.createElement('img');
                            imgElement.src = imgData;
                            imgElement.style.maxWidth = "100%";
                            imgElement.style.marginTop = "15px";
                            imgElement.style.pageBreakInside = "avoid";
                            imgElement.alt = `File ${i + 1}`;

                            imagesDiv.appendChild(imgElement);
                        }
                    } catch (err) {
                        console.error(`Error processing image ${fileUrl}:`, err);
                    }
                }

                // Append images div to the temp container
                tempContainer.appendChild(imagesDiv);

                // Close loading indicator
                Swal.close();

                // Replace body content with our prepared content
                document.body.innerHTML = tempContainer.innerHTML;

                // Add print styling
                const style = document.createElement('style');
                style.textContent = `
                    @media print {
                        img { max-width: 100%; page-break-inside: avoid; }
                        @page { margin: 1cm; }
                    }
                `;
                document.head.appendChild(style);

                // Print with a small delay to ensure rendering
                setTimeout(() => {
                    window.print();

                    // After printing, restore the original content
                    document.body.innerHTML = originalContents;
                    window.location.reload(); // Ensure styles and scripts are reapplied
                }, 300);
            } catch (error) {
                console.error("Error during print preparation:", error);
                Swal.fire('Error', 'There was an error preparing the print', 'error');
                document.body.innerHTML = originalContents;
                window.location.reload(); // Ensure styles and scripts are reapplied
            }
        }
    };

    const handleEdit = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to View this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });

        if (result.isConfirmed) {
            setSelectedRow(row);
            console.log("SELeceted DATA: ", row)

            $('#editRowModal').modal('show');
        }
    };

    const openaadhar = (row) => {
        console.log(row)
        const fileUrl = row.files?.aadhar_file?.url;
        if (fileUrl) {
            window.open(fileUrl, "_blank"); // Opens the file in a new tab
        } else {
            alert("Aadhar file not available.");
        }
    };

    const openrc = (row) => {
        const fileUrl = row.files?.rc_file?.url;
        if (fileUrl) {
            window.open(fileUrl, "_blank"); // Opens the file in a new tab
        } else {
            alert("RC Book file not available.");
        }
    };

    const openphoto = (row) => {
        const fileUrl = row.files?.photowithbike_file?.url;
        if (fileUrl) {
            window.open(fileUrl, "_blank"); // Opens the file in a new tab
        } else {
            alert("Photo not available.");
        }
    };


    const filteredData = data?.filter(item => {
        const search = searchText?.toLowerCase() || "";
        const reg = item.reg_no?.toLowerCase() || "";
        const name = item.billing_details?.buyer_name?.toLowerCase() || "";
        const phone = item.billing_details?.buyer_phone1?.toLowerCase() || "";
        const model = item.billing_details?.bike_model?.toLowerCase() || "";
        return (
            reg.includes(search) ||
            name.includes(search) ||
            phone.includes(search) ||
            model.includes(search)
        );
    }) || [];



    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.reg_no || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Bill Date</span>,
            selector: row => {
                if (!row.billing_details?.date) return ""; // Handle empty dates

                const date = new Date(row.billing_details.date);
                return date.toLocaleDateString("en-GB"); // Formats as DD/MM/YYYY
            },
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Buyer Name</span>,
            selector: row => row.billing_details?.buyer_name || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Phone</span>,
            selector: row => row.billing_details?.buyer_phone1 || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Amount</span>,
            selector: row => row.billing_details?.amount ? `₹${row.billing_details.amount}` : "",
            sortable: true,
            width: '140px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Model</span>,
            selector: row => row.billing_details?.bike_model || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleEdit(row)} className="btn btn-primary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-eye"></i>
                    </button>
                    <button onClick={() => openaadhar(row)} className="btn btn-secoundary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-user"></i>
                    </button>
                    <button onClick={() => openrc(row)} className="btn btn-secoundary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-book"></i>
                    </button>
                    <button onClick={() => openphoto(row)} className="btn btn-secoundary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-user-circle"></i>
                    </button>
                    <button onClick={() => printBill(row)} className="btn btn-success btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-print"></i>
                    </button>
                    {/* ✅ New download button */}
                    <button onClick={() => downloadPDF(row)} className="btn btn-danger btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-download"></i>
                    </button>
                </div>
            ),
            width: '250px'
        }
    ];


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Buyer Search</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Buyer Search</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>



            {data && (
                <div className="row mb-2 mt-2">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}  // Set number of rows per page
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                />

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-xl">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Bill</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                {selectedRow && selectedRow.billing_details && Object.keys(selectedRow.billing_details).length > 0 && (
                                                    <div className="container-fluid">

                                                        {/* Header Section */}
                                                        <div className="row mb-3">
                                                            <div className="col-6 col-md-4">
                                                                <p><strong>Bill No:</strong> {selectedRow.bill_no || ""}</p>
                                                                <p><strong>Date:</strong> {selectedRow.billing_details.date || ""}</p>
                                                            </div>
                                                            <div className="col-12 col-md-4 text-center">
                                                                <h4><strong>DELIVERY NOTE</strong></h4>
                                                            </div>
                                                            <div className="col-6 col-md-4 text-center">
                                                                <img
                                                                    src={selectedRow?.files?.photo_file?.url || ""}
                                                                    alt="Buyer"
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "120px" }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Buyer & Seller Info */}
                                                        <div className="row mb-3">
                                                            <div className="col-md-6">
                                                                <h5><span className="text-primary">Buyer</span>:</h5>
                                                                <p>{selectedRow.billing_details.buyer_name}</p>
                                                                <p>{selectedRow.billing_details.buyer_address1}</p>
                                                                <p>{selectedRow.billing_details.buyer_address2}</p>
                                                                <p>{selectedRow.billing_details.buyer_city}</p>
                                                                <p><strong>Phone:</strong> {selectedRow.billing_details.buyer_phone1}, {selectedRow.billing_details.buyer_phone2}</p>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <h5><span className="text-primary">Seller</span>:</h5>
                                                                <p>{selectedRow.billing_details.seller_name}</p>
                                                                <p>{selectedRow.billing_details.seller_address1}</p>
                                                                <p>{selectedRow.billing_details.seller_address2}</p>
                                                                <p>{selectedRow.billing_details.seller_city}</p>
                                                                <p><strong>Phone:</strong> {selectedRow.billing_details.seller_phone1}, {selectedRow.billing_details.seller_phone2}</p>
                                                            </div>
                                                        </div>

                                                        {/* Letter Body */}
                                                        <div className="row mb-3">
                                                            <div className="col-12">
                                                                <p><strong>Sir,</strong></p>
                                                                <p><strong>Ref:</strong> {selectedRow.reg_no} / {selectedRow.billing_details.bike_model} {selectedRow.billing_details.bike_color}</p>
                                                                <p>I have this day purchased the above vehicle from you for the sum of Rs.<strong> {selectedRow.billing_details.amount}</strong> (Rupees in Words: <strong>{selectedRow.billing_details.amountinwords}</strong>) and I have taken delivery of the said vehicle to my satisfaction.</p>
                                                                <p>The entire risk is being borne by me/us from <strong>{selectedRow.billing_details.date_time}</strong></p>
                                                            </div>
                                                        </div>

                                                        {/* Vehicle and Payment Details */}
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <h5><mark>Vehicle Details</mark></h5>
                                                                <p><strong>Make:</strong> {selectedRow.billing_details.bike_make_year}</p>
                                                                <p><strong>Chase No:</strong> {selectedRow.billing_details.bike_chase_no}</p>
                                                                <p><strong>Engine No:</strong> {selectedRow.billing_details.bike_engine_no}</p>
                                                                <p><strong>Exchange Registration No:</strong> {selectedRow.billing_details.exchange_reg_no}</p>
                                                                <p><strong>Exchange Bike:</strong> {selectedRow.billing_details.exchange_bike_model}</p>
                                                                <p><strong>Color:</strong> {selectedRow.billing_details.exchange_bike_color}</p>
                                                                <p><strong>Exchange Amount:</strong> {selectedRow.billing_details.exchange_amount}</p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <h5><mark>Payment Details</mark></h5>
                                                                <p><strong>1) Payment Type:</strong> {selectedRow.billing_details.payment_type1} / {selectedRow.billing_details.cash_paid1}</p>
                                                                <p><strong>2) Payment Type:</strong> {selectedRow.billing_details.payment_type2} / {selectedRow.billing_details.cash_paid2}</p>
                                                                <p><strong>Finance Amount:</strong> {selectedRow.billing_details.finance_amount}</p>
                                                                <p><strong>EMI Tenure:</strong> {selectedRow.billing_details.emi_tenure}</p>
                                                                <p><strong>Monthly EMI:</strong> {selectedRow.billing_details.emi_amount}</p>
                                                                <p><strong>EMI Date:</strong> {selectedRow.billing_details.due_date}</p>
                                                            </div>
                                                        </div>

                                                        {/* Tamil Notes */}
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                                                                <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                                                                <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                                                                <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/*Print Bill*/}


            {selectedRow && (
                <div id="download_section" style={{ display: "none" }}>
                    {selectedRow && selectedRow.billing_details && Object.keys(selectedRow.billing_details).length > 0 && (
                        <div className="delivery-note-container">
                            <div class="note-header">
                                <div class="note-header-left">
                                    <img
                                        src={`https://apiemiride.socialpartners.in/api/company/logo/${encodeURIComponent(localStorage.getItem('company_logo') || '')}`}
                                        alt="Company Logo"
                                        className="company-logo"
                                        onError={(e) => { e.target.style.display = "none"; }}
                                    />
                                </div>
                                <div class="note-header-center">
                                    <h1 class="brand-name">{company.company_name}</h1>
                                    <p class="brand-tamil">{company.tagline}</p>
                                    <p class="brand-line">BUYING - SELLING - EXCHANGE</p>
                                </div>
                                <div class="note-header-right">
                                    <p><i class="fas fa-map-marker-alt location-icon"></i> {company.company_address1}</p>
                                    <p><i class="fas fa-map-marker-alt location-icon"></i> {company.company_address2} , {company.company_city}</p>
                                    <p><i class="fa fa-solid fa-phone location-icon"></i> {company.company_phone1}, {company.company_phone2}</p>
                                </div>
                            </div>

                            <div className="delivery-note-section">
                                {/* Left Section for DN No. and Date */}
                                <div className="delivery-note-left">
                                    <p><strong>Bill No:</strong>{selectedRow.bill_no}</p>
                                    <p><strong>Date:</strong>{selectedRow.billing_details.date}</p>
                                </div>
                                <div className="delivery-note-header">
                                    <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                                </div>

                                {/* Right Section for Image */}

                                <div className="delivery-note-image">
                                    <div className={`delivery-note-image-container ${!selectedRow.files?.photo_file ? 'no-border' : ''}`}>
                                        <img
                                            src={
                                                selectedRow.files?.photo_file?.url
                                                    ? selectedRow.files.photo_file.url
                                                    : "https://via.placeholder.com/160x160/ffffff/ffffff.png"
                                            }
                                            alt="Buyer"
                                            className="fixed-image"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="delivery-note-info">
                                <div>
                                    <h3 className="delivery-note-fromto"><span className="highlight-text">Buyer</span>:</h3>
                                    <p><strong><b>{selectedRow.billing_details.buyer_name}</b></strong></p>
                                    <p>{selectedRow.billing_details.buyer_address1}</p>
                                    <p>{selectedRow.billing_details.buyer_address2} , {selectedRow.billing_details.buyer_city}</p>
                                    <p>
                                        <strong>Phone:</strong> <strong><b>{selectedRow.billing_details.buyer_phone1}, {selectedRow.billing_details.buyer_phone2}</b></strong>
                                    </p>
                                </div>
                                <div>
                                    <h3 className="delivery-note-fromto"><span className="highlight-text">Seller</span>:</h3>
                                    <p><strong><b>{selectedRow.billing_details.seller_name}</b></strong></p>
                                    <p>{selectedRow.billing_details.seller_address1}</p>
                                    <p>{selectedRow.billing_details.seller_address2} , {selectedRow.billing_details.seller_city}</p>
                                    <p>
                                        <strong>Phone:</strong> <strong><b>{selectedRow.billing_details.seller_phone1}, {selectedRow.billing_details.seller_phone2}</b></strong>
                                    </p>
                                </div>
                            </div>

                            <div className="delivery-note-right-align">
                                <p><strong>Sir,</strong></p>
                                <div className="letter-content">
                                    <p><span className="highlight-text"><strong>Ref:</strong><strong><b> {selectedRow.reg_no} </b></strong>/ {selectedRow.billing_details.bike_model} {selectedRow.billing_details.bike_color}</span></p>
                                    <p>
                                        I have this day purchased the above vehicle from you for the sum of Rs.<strong> <b>{selectedRow.billing_details.amount}</b></strong> (Rupees in Words: <strong> {selectedRow.billing_details.amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                    </p>
                                    <p>
                                        The entire risk is being bome by me / us / from this time <strong>
                                            <b>
                                                {new Date(selectedRow.billing_details.date_time).toLocaleString("en-GB", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true
                                                })}
                                            </b>
                                        </strong>
                                    </p>
                                </div>
                            </div>

                            <div className="delivery-note-row">
                                {/* Left: Vehicle Details */}
                                <div className="delivery-note-vehicle-details">
                                    <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark></h3>
                                    <p><strong>Make:</strong><span>{selectedRow.billing_details.bike_make_year}</span></p>
                                    <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.bike_chase_no}</span></p>
                                    <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.bike_engine_no}</span></p>
                                    <p><strong><mark className="highlight-text">Exchange Details:</mark></strong></p>
                                    <p><strong>Registration No:</strong><span> {selectedRow.billing_details.exchange_reg_no}</span></p>
                                    <p><strong>Exchange Bike:</strong><span> {selectedRow.billing_details.exchange_bike_model}</span></p>
                                    <p><strong>Color:</strong> <span>{selectedRow.billing_details.exchange_bike_color}</span></p>
                                    <p><strong>Exchange Amount:</strong> <span>{selectedRow.billing_details.exchange_amount}</span></p>
                                </div>

                                {/* Right: Payment Details */}
                                <div className="delivery-note-payment">
                                    <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark></h3>
                                    <p><strong>1) Payment Type:</strong><span>{selectedRow.billing_details.cash_paid1} / {selectedRow.billing_details.payment_type1}</span></p>
                                    <p><strong>2) Payment Type:</strong><span>{selectedRow.billing_details.cash_paid2} / {selectedRow.billing_details.payment_type2}</span></p>
                                    <p><strong><mark className="highlight-text">Finance Details:</mark></strong></p>
                                    <p><strong>Finance Amount:</strong><span> {selectedRow.billing_details.finance_amount}</span></p>
                                    <p><strong>EMI Tenure:</strong> <span>{selectedRow.billing_details.emi_tenure}</span></p>
                                    <p><strong>Monthly EMI:</strong> <span>{selectedRow.billing_details.emi_amount}</span></p>
                                    <p><strong>EMI Date:</strong> <span>{selectedRow.billing_details.due_date}</span></p>

                                </div>
                            </div>

                            <div className="delivery-note-tamil-text">
                                <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                                <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                                <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எக்காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                                <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                            </div>

                            <div className="delivery-note-signatures">
                                <div>
                                    <p>
                                        <strong>Signature of Buyer</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Buyer